import { useMemo } from 'react';

import { FilterButton } from '@/components/atoms';
import { useGetArticleCategoriesQuery } from '@/graphql/generated';
import { useLocale } from '@/hooks';

type ArticleCategoryFilterProps = {
  selectedCategoryId: string | undefined;
  onSelectCategory: (id?: string) => void;
};

export const ArticleCategoryFilter = ({ selectedCategoryId, onSelectCategory }: ArticleCategoryFilterProps) => {
  const locale = useLocale();

  const categories = useGetArticleCategoriesQuery({ locale }).data?.articleCategories?.data;
  const articleCategories = useMemo(
    () =>
      categories?.map((category) => ({
        id: category.id || '',
        name: category.attributes?.name || '',
      })) || [],
    [categories],
  );

  return (
    <>
      <FilterButton label="🌍 All" selected={!selectedCategoryId} onClick={() => onSelectCategory(undefined)} />
      {articleCategories.map((category) => (
        <FilterButton
          key={`filter_button_${category.id}`}
          selected={category.id === selectedCategoryId}
          label={category.name}
          onClick={() => onSelectCategory(category.id)}
        />
      ))}
    </>
  );
};
